/* eslint-disable no-case-declarations */
import { MISC_MODAL_ADD, MISC_MODAL_REMOVE } from '../../constants/ActionTypes';

const miscModals = (
  state = {
    modals: {},
  },
  action
) => {
  switch (action.type) {
    case MISC_MODAL_ADD:
      const newModalsAdd = { ...state.modals };

      newModalsAdd[action.name] = {
        ...action.data,
        open: true,
      };

      return { ...state, modals: newModalsAdd };
    case MISC_MODAL_REMOVE:
      const newModalsRemove = { ...state.modals };

      delete newModalsRemove[action.name];

      return { ...state, modals: newModalsRemove };
    default:
      return state;
  }
};

export default miscModals;
